import React from 'react'
import {Icon} from '@salesforce/retail-react-app/app/components/shared/ui'

const CutleryIcon = (props) => {
    return (
        <Icon viewBox="0 0 40 41" width="40" height="41" {...props}>
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M13.4048 1.15625V38.8438H10.4048V1.15625H13.4048Z"
                fill="currentColor"
            />
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M8.77979 1.15625V13.06C8.78279 13.8885 9.11324 14.6823 9.69912 15.2682C10.2844 15.8535 11.0772 16.1838 11.9048 16.1875C12.7324 16.1838 13.5251 15.8535 14.1105 15.2682C14.6963 14.6823 15.0268 13.8885 15.0298 13.06V1.15625H18.0298V13.0625L18.0298 13.067C18.0249 14.6888 17.3785 16.2427 16.2318 17.3895C15.085 18.5363 13.531 19.1826 11.9093 19.1875H11.9003C10.2785 19.1826 8.72457 18.5363 7.5778 17.3895C6.43103 16.2427 5.78464 14.6888 5.77979 13.067L5.77979 13.0625V1.15625H8.77979Z"
                fill="currentColor"
            />
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M26.1884 1.26544C26.7373 1.10333 27.3237 1.12214 27.861 1.3191C28.3983 1.51606 28.8579 1.88071 29.1719 2.35911L29.181 2.37315C33.6933 9.41773 33.9669 16.7407 34.213 23.3268L34.216 23.4088C34.216 23.4092 34.2161 23.4095 34.2161 23.4099C34.2355 23.9228 34.1488 24.4342 33.9614 24.912C33.7739 25.3902 33.4897 25.8246 33.1265 26.1878C32.7633 26.551 32.329 26.8352 31.8508 27.0227C31.3826 27.2063 30.8822 27.2932 30.3797 27.2784H27.2781V38.8409H24.2781V3.80468C24.2817 3.23244 24.4695 2.67657 24.8135 2.21928C25.1576 1.76199 25.6396 1.42756 26.1884 1.26544ZM27.2781 24.2784H30.4046C30.4237 24.2784 30.4427 24.2788 30.4617 24.2795C30.5621 24.2833 30.6622 24.2664 30.7557 24.2297C30.8492 24.193 30.9341 24.1375 31.0051 24.0664C31.0762 23.9954 31.1318 23.9105 31.1684 23.817C31.2051 23.7235 31.222 23.6234 31.2182 23.523L31.2182 23.5219C30.9822 17.2083 30.7192 11.0004 27.2781 5.01726V24.2784Z"
                fill="currentColor"
            />
        </Icon>
    )
}

export default CutleryIcon
